
/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

import './bootstrap.js';

//import $ from 'jquery';//V3.7.1
//window.$ = window.jQuery = $;

window.Vue = require('vue');
//PNotify
window.PNotify = require('@pnotify/core');
window.PNotifyConfirm = require('@pnotify/confirm');
window.PNotifyBootstrap4 = require('@pnotify/bootstrap4');
window.PNotifyFontAwesome4 = require('@pnotify/font-awesome4');
window.PNotifyMobile = require('@pnotify/mobile');
PNotify.defaultModules.set(PNotifyBootstrap4, {});
PNotify.defaultModules.set(PNotifyFontAwesome4, {});
PNotify.defaultModules.set(PNotifyMobile, {});
//Pnotify Desktop
//window.PNotifyDesktop = require ( '@pnotify/desktop/dist/PNotifyDesktop.js' );
//import * as PNotifyDesktop from '@pnotify/desktop';

require('jquery-ui/ui/widgets/draggable');
require('bootstrap-select');
require('jquery-contextmenu');

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i);
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default));
import Echo from 'laravel-echo';
import Pusher from 'pusher-js';

window.Pusher = Pusher;
if (!window.Echo) {
    window.Echo = new Echo({
        broadcaster: 'reverb',
        key: 'local',
        wsHost: window.location.hostname,
        wsPort: 443,
        wssPort: 443,
        scheme: 'https',
        forceTLS: true,
        enabledTransports: ['ws', 'wss'],
        authEndpoint: '/broadcasting/auth',
        withCredentials: true
    });
    window.addEventListener('beforeunload', () => {
        if (window.Echo) {
            window.Echo.disconnect();
        }
    });
}
//ARES => Apolo Realtime Event Service
window.ARES = {
    listenPublic(channel, event, callback) {
        window.Echo.channel(channel).listen(event, callback);
    },
    listen(channel, event, callback) {
        window.Echo.private(channel).listen(event, callback);
    },
    join(channel, hereCallback, joiningCallback, leftCallback) {
        window.Echo.join(channel)
            .here(hereCallback)
            .joining(joiningCallback)
            .leaving(leftCallback);
    },
    leave(channel) {
        window.Echo.leave(channel);
    }
};

import QRCode from 'qrcode';

window.QRCode = QRCode;

import DataTablesEdit from './dataTablesEdit/DataTablesEdit.v.1.13.js';

window.DataTablesEdit = DataTablesEdit;

import Vue from 'vue';

Vue.component('example-component', require('./components/ExampleComponent.vue').default);



/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

const app = new Vue({
    el: '#app',
});

//to deactivate context menu
/*document.addEventListener('contextmenu', function (e) {
    // Get the real element under the cursor (even if event.target is document)
    const realTarget = document.elementFromPoint(e.clientX, e.clientY);

    // Check if it's inside an element that allows the custom context menu
    const allowedEl = realTarget?.closest('.custom-context');

    if (allowedEl) { 
    } else {
        e.preventDefault(); // block browser menu
        e.stopImmediatePropagation();
        return false
        //e.stopPropagation();
    }
});*/

